import { of as observableOf, Subject, Observable, of, Subscriber } from 'rxjs';
import { Injectable } from "@angular/core";
import { SabisNgxModalsModule } from './sabis-modals.module';
import { SabisTranslateService } from '../translation/sdp-translate.service';
import { SabisNgxModalDialogComponent } from './inputs-dialog/inputs-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ActionCallback, ModalArgs, ModalInput, ModalResult, ModalType } from './models';



@Injectable({
  providedIn: SabisNgxModalsModule
})
export class SabisNgxModalsService {

  constructor(private _translate: SabisTranslateService, public dialog: MatDialog) { }


  private showModalInternal(args: ModalArgs): Observable<ModalResult> {
    let result = new Observable((s: Subscriber<ModalResult>) => {
      var dialog = this.dialog.open(SabisNgxModalDialogComponent, {
        hasBackdrop: true,
        panelClass: ['sc-modal'],
        data: args
      });
      dialog.afterClosed().subscribe(r => {
        let modalResult: ModalResult = !!r ? r : { confirmed: null, inputsValue: [] };
        s.next(modalResult);
        s.complete();
      });
    });

    return result;
  }

  /**
   * Show notification dialog, with "Yes/No" buttons
   * @param message specify the text message to display
   * @param title specify the dialog title
   */
  public showModal(message: string | string[], title: string, type: ModalType, inputs: ModalInput[], callback: ActionCallback): Observable<ModalResult>;
  /**
   * 
   * @param message
   * @param title
   * @param confirmButtonName
   */
  public showModal(message: string | string[], title: string, type: ModalType, inputs: ModalInput[], callback: ActionCallback, confirmButtonName: string, discardButtonName?: string): Observable<ModalResult>;
  public showModal(message: string | string[], title: string, type: ModalType, inputs: ModalInput[], callback: ActionCallback, confirmButtonName?: string, discardButtonName?: string): Observable<ModalResult> {
    type = type ? type : ModalType.Notification;
    var args: ModalArgs = {
      title: title,
      message: message,
      type: ModalType.Notification,
      confirmButtonName: confirmButtonName ? confirmButtonName : this._translate.instant('Yes'),
      discardButtonName: discardButtonName ? discardButtonName : this._translate.instant('No'),
      inputs: inputs!,
      onActionCallback: callback
    };

    let result = this.showModalInternal(args);

    return result;
  }
}
